import { Divider, Typography } from "@mui/material"
import type { FC } from "react"

import { AerosDatePicker } from "@/components/UiKit"

interface InventoryDateRangeFilterProps {
  label: string
  fromLabel?: string
  toLabel?: string
  dateFrom: string | null
  dateTo: string | null
  onDateFromChange: (value: string | null) => void
  onDateToChange: (value: string | null) => void
  testId: string
}

export const InventoryDateRangeFilter: FC<InventoryDateRangeFilterProps> = ({
  label,
  fromLabel = "From",
  toLabel = "To",
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  testId,
}) => {
  const isDateRangeInvalid = !!dateFrom && !!dateTo && dateTo < dateFrom

  return (
    <div data-testid={testId}>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        {label}
      </Typography>
      <Divider className='mb-4' />
      <div className='flex flex-col gap-4 px-4'>
        <AerosDatePicker
          label={fromLabel}
          value={dateFrom}
          onChange={onDateFromChange}
          error={isDateRangeInvalid}
          data-testid={`${testId}.date-from-field`}
        />
        <AerosDatePicker
          label={toLabel}
          value={dateTo}
          onChange={onDateToChange}
          error={isDateRangeInvalid}
          helperText={isDateRangeInvalid ? "From date must be before To date" : undefined}
          data-testid={`${testId}.date-to-field`}
        />
      </div>
    </div>
  )
}
